<template>
    <div>
        <b-modal id="modal-Website" size="lg" class="modal-form" @show="getAgents(formwebsite.user_id ? formwebsite.user_id : 1);" :title="modal_title" @hidden="CLEAR_FORM_WEBSITE_LIST()" centered hide-footer>
            <ValidationObserver ref="form">

                <validation-provider rules="required" v-slot="{ errors }">
                    <div class="form-group">
                        <label>Agent Name</label>
                        <v-select :clearable="false" label="name" :reduce="agents => agents.id" v-model="formwebsite.user_id" :options="agents">
                            <template v-slot:option="option">
                                {{ option.name }} - {{option.email}}
                            </template>
                            <template #selected-option="option">
                                {{ option.name }} - {{option.email}}
                            </template>
                        
                        </v-select>
                        <div class="invalid-input">{{ errors[0] }}</div>
                    </div>
                </validation-provider>

                <div class="d-flex">
                    <label class="pl-0 custom-switch switch-big">
                        <input v-model="formwebsite.is_active" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                        <span class="custom-switch-indicator"></span>
                    </label>
                    <label class="mt-3 ml-3">
                        <span class="custom-switch-description ml-0"><strong>Active Website</strong></span>
                        <p class="desc">This function is used to active or deactive website</p>
                    </label>
                </div>
                
                <validation-provider v-if="!formwebsite.logo" rules="mimes:image/jpeg,image/png,image/jpg|required" v-slot="{ errors, validate }">
                    <div class="form-group" v-if="!formwebsite.logo">
                        <div class="mb-1">
                            <label>Website Logo</label>
                        </div>
                        <div class="btn-up d-flex align-items-center" v-on:click.prevent="$refs.inputImage.click()">
                            <div class="upload"><i class="uil uil-image mr-1"></i> ADD IMAGE</div>
                        </div>
                        <input ref="inputImage" 
                                type="file"
                                class="custom-file-input d-none"
                                id="Thumbnail"
                                v-on:change="onImageUpload"
                                accept="image/jpeg,image/png,image/jpg" 
                                @input="validate" >
    
                        <div class="invalid-input mt-3">{{ errors[0] }}</div>
                    </div>
                </validation-provider>
                
                <div class="form-group" v-if="formwebsite.logo">   
                    <div class="mb-1">
                        <label>Website Logo</label>
                    </div> 
                    <button v-on:click.prevent="removeImageUpload()" type="button" class="btn-remove-image"><i class="uil uil-times"></i> Delete Website</button> 
                    <div class="input-group img-sh">
                        <img style="width: 200px;object-fit: cover;" :src="formwebsite.logo" class="img-responsive img-prf">
                    </div>
                    <div class="invalid-input mt-3">{{ errors[0] }}</div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <validation-provider rules="required" v-slot="{ errors }">
                            <div class="form-group">
                                <label>Website Name</label>
                                <input v-model="formwebsite.name" type="text" class="form-control" name="name">
                                <div class="invalid-input">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                    </div>
                    <div class="col-md-6">
                        <validation-provider rules="required" v-slot="{ errors }">
                            <div class="form-group">
                                <label>Domain Name</label>
                                <input v-model="formwebsite.domain" type="text" class="form-control" name="name">
                                <div class="invalid-input">{{ errors[0] }}</div>
                                <small>format domain must example.com, dont put protocol</small>
                            </div>
                        </validation-provider>
                    </div>
                    <div class="col-md-6">
                        <validation-provider rules="required" v-slot="{ errors }">
                            <div class="form-group">
                                <label>Expired Date</label>
                                <datetime v-model="formwebsite.expired_date" zone='local' value-zone='local' type="date" input-class="form-control"></datetime>
                                <div class="invalid-input">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                    </div>

                    <div class="col-md-4">
                        <validation-provider rules="email" v-slot="{ errors }">
                            <div class="form-group">
                                <label>Email</label>
                                <input v-model="formwebsite.email" type="text" class="form-control" name="name">
                                <div class="invalid-input">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                    </div>
                    <div class="col-md-4">
                        <validation-provider rules="numeric" v-slot="{ errors }">
                            <div class="form-group">
                                <label>Phone</label>
                                <input v-model="formwebsite.phone" type="text" class="form-control" name="name">
                                <div class="invalid-input">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                    </div>
                    <div class="col-md-4">
                        <validation-provider rules="required|numeric" v-slot="{ errors }">
                            <div class="form-group">
                                <label>Whatsapp</label>
                                <input v-model="formwebsite.whatsapp" type="text" class="form-control" name="name">
                                <div class="invalid-input">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>Address</label>
                            <input v-model="formwebsite.address" type="text" class="form-control" name="name">
                        </div>
                    </div>
                    <div class="col-md-12">  
                        <validation-provider rules="multi_url" v-slot="{ errors }">
                            <div class="form-group">
                                <label>Social Media</label>
                                <textarea v-model="formwebsite.sosmed" class="form-control"></textarea>
                                <small>Separate urls with commas(,) if you want to load more than one link</small>
                                <div class="invalid-input">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                    </div>
                </div>

                <div class="button-modal text-right">
                    <button v-on:click="validationForm(formwebsite.id)" type="button" class="btn btn-new" v-bind:class="loading ? 'btn-progress' : ''">
                        Save Data
                    </button>
                </div>
            </ValidationObserver>
        </b-modal>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'
    import {ValidationProvider, ValidationObserver} from "vee-validate";
    import { Datetime } from 'vue-datetime';
    import vSelect from 'vue-select'

    export default{
        data(){
            return{
                loading:false,
                modal_title : 'Add Website',
                logo_file:'',
                selected_agent:'',
            }
        },
        props: ['del_website'],
        components: {
            ValidationProvider,
            ValidationObserver,
            Datetime,
            vSelect
        },
        computed: {
            ...mapState('WebsiteControl', {
                formwebsite: state => state.formwebsite,
                errors: state => state.errors
            }),
            ...mapState('SelectControl', {
                agents: state => state.agents,
            }),
        },
        watch:{
            'formwebsite':function(val){
                if(val.id){
                    this.modal_title = 'Edit Website'
                }else if(!val.id){
                    this.modal_title = "Add Website"
                }
            },
        },
        methods: {
            ...mapActions('WebsiteControl', ['createWebsiteList','updateWebsiteList']),
            ...mapMutations('WebsiteControl', ['CLEAR_FORM_WEBSITE_LIST']),
            ...mapActions('SelectControl', ['getAgents']),

            onImageUpload: function(event) {
                var input = event.target;

                if (input.files && input.files[0]) {

                    var reader = new FileReader();
                    var vm = this;
                    reader.onload = function(e) {
                        vm.formwebsite.logo = e.target.result;
                    }
                    reader.readAsDataURL(input.files[0]);
                }
                this.logo_file = input.files[0]
            },
            removeImageUpload:function(){
                this.logo_file = ''
                this.formwebsite.logo = ''
            },
            validationForm: function(id) {
                this.$refs.form.validate().then(success => {
                    if (!success) {
                        setTimeout(() => {
                            const errors = Object.entries(this.$refs.form.errors)
                                .map(([key, value]) => ({ key, value }))
                                .filter(error => error["value"].length);
                            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }, 100);
                    }else{
                        this.loading = true

                        var formData = new FormData();
                        formData.append('user_id', this.formwebsite.user_id);
                        formData.append('name', this.formwebsite.name);
                        formData.append('domain', this.formwebsite.domain);
                        formData.append('expired_date', this.formwebsite.expired_date);
                        formData.append('is_active', this.formwebsite.is_active);
                        formData.append('email', this.formwebsite.email ? this.formwebsite.email : '');
                        formData.append('phone', this.formwebsite.phone ? this.formwebsite.phone : '');
                        formData.append('whatsapp', this.formwebsite.whatsapp ? this.formwebsite.whatsapp : '');
                        formData.append('address', this.formwebsite.address ? this.formwebsite.address : '');
                        formData.append('sosmed', this.formwebsite.sosmed ? this.formwebsite.sosmed : '');
                        formData.append('logo', this.formwebsite.logo ? this.formwebsite.logo : '');
                        formData.append('logo_file', this.logo_file);
                        
                        if(id){

                            formData.append("_method", "put");
                            this.updateWebsiteList(formData).then(() => {
                                this.loading = false
                                this.logo_file = ''
                                this.$bvModal.hide('modal-Website')
                                this.$emit('getWebsiteList');
                                this.$toast.success('Successfully Update Website')
                            }).catch((error) => {
                                console.log(error)
                                this.loading = false
                                this.$toast.warning('Sorry, Something Error')
                            })

                        }else{

                            this.createWebsiteList(formData).then(() => {
                                this.loading = false
                                this.logo_file = ''
                                this.$bvModal.hide('modal-Website')
                                this.$emit('getWebsiteList');
                                this.$toast.success('Successfully Added Website')
                            }).catch((error) => {
                                console.log(error)
                                this.loading = false
                                this.$toast.warning('Sorry, Something Error')
                            })
                        }
                    }
                });
            },
        }
    }
</script>
